import { render, staticRenderFns } from "./comp-rab-info.vue?vue&type=template&id=3acb60bd&scoped=true&"
import script from "./comp-rab-info.vue?vue&type=script&lang=js&"
export * from "./comp-rab-info.vue?vue&type=script&lang=js&"
import style0 from "./comp-rab-info.vue?vue&type=style&index=0&id=3acb60bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb60bd",
  null
  
)

export default component.exports